__turbopack_context__.v({
  "pr-reviewdisplay": "ReviewsRatings-module-scss-module__hXFoNa__pr-reviewdisplay",
  "reviewsRatings": "ReviewsRatings-module-scss-module__hXFoNa__reviewsRatings",
  "title": "ReviewsRatings-module-scss-module__hXFoNa__title",
});
